import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import ButtonTable from '../common/table/buttonTable';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { setModoTela, initForm } from './estoqueActions';

class EstoqueForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
	
							<Field
								name='datahora_estoque'
								component={LabelAndInputMask}
								label='Data/Hora'
								cols='12 12 12 12'
								placeholder='Selecione o tipo'
								mask='99/99/9999 99:99'
								readOnly={readOnly} />

							<Field
								name='id_tipo_manual'
								component={Select}
								options={[{ id: '1', valor: 'Entrada por Quebra' }, { id: '2', valor: 'Saída por Quebra' }, { id: '3', valor: 'Ajuste de Saldo' }]}
								label='Tipo'
								cols='12 12 12 12'
								placeholder='Selecione o tipo'
								readOnly={readOnly} />

							<Field
								name='id_unidade'
								component={Select}
								options={this.props.listaUnidade}
								label='Unidade'
								cols='12 12 12 12'
								placeholder='Selecione a unidade'
								readOnly={readOnly} />
								
							<Field
								name='id_produto'
								component={Select}
								options={this.props.listaProduto}
								label='Produto'
								cols='12 12 12 12'
								placeholder='Selecione o produto'
								readOnly={readOnly} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe a observação'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade' placeholder='Informe a quantidade'
								cols='12 6 4 4'
								casas={2}
								readOnly={readOnly} />
							               
						
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

EstoqueForm = reduxForm({form: 'estoqueForm', destroyOnUnmount: false})(EstoqueForm);
const mapStateToProps = state => ({
	sessao: state.auth.estoque,
	formularioValues: getFormValues('estoqueForm')(state),
	registro: state.estoque.registro,
	listaProduto: state.estoque.listaProduto,
	listaUnidade: state.estoque.listaUnidade,
	listaTipo: state.estoque.listaTipo,
	listaTanque: state.estoque.listaTanque,
    listaMotorista: state.estoque.listaMotorista,
    listaVeiculo: state.estoque.listaVeiculo,
    listaDistribuidora: state.estoque.listaDistribuidora,
    listaPedido: state.estoque.listaPedido
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EstoqueForm);
